<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Alert, Toggle } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';
	import { callBluTRV, getTrvComponentByDevice } from 'src/helpers/virtual_helpers/blutrv_helpers';
	import type { Device } from 'src/types/Device';

	export let device: Device;
	let waitForResponse = false;

	let enableTrv = getTrvComponentByDevice(device)?.config?.['trv:0']?.enable;

	const handleEnableTrv = async () => {
		waitForResponse = true;
		enableTrv = !enableTrv;
		await callBluTRV(device, 'Trv.Setconfig', {
			id: 0,
			config: { enable: enableTrv },
		});
		waitForResponse = false;
	};
</script>

<Alert
	class="mb-s"
	type="warning"
	heading={capFirstChar(
		$format('alert_warning_generic_attention', {
			default: 'Attention!',
		}),
	)}
	isHeadingBold
	message={$format('blutrv_enable_warning_message_description', {
		default:
			'If disabled, the TRV would not open/close the valve automatically, which is suitable only if using advanced API calls to control the valve position manually.',
	})}
/>
<Toggle
	loading={waitForResponse}
	disabled={waitForResponse}
	checked={enableTrv}
	size="m"
	on:click={handleEnableTrv}
	id="toggle-vnmklrb"
>
	{$format('trv_auto_description', {
		default: 'Enable automatic temperature control',
	})}
</Toggle>
